<template>
  <div class="wrapper-overlay open-overlay">
    <OverlayHeader />

    <div class="container-overlay overlay-form">
        <div class="overlay-message">
            <div v-html="selectedBundle.notes"></div>
        </div>
    </div>


  </div>
</template>


<script>
import OverlayHeader from "@/components/OverlayHeader.vue"
import store from '@/store/index'

export default {
  name: "ClarificationsModal",
  components: {
    OverlayHeader
  },
  computed: {
    selectedBundle() {
        return store.state.selectedBundle;
    }
  }
};
</script>